import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// 导入Element UI并全局注册
import ElementUI from 'element-ui';
import { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 确保Element UI被正确注册
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$loading = Loading.service;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');